import { Component, OnInit, signal } from '@angular/core';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import * as AOS from 'aos';
import { filter } from 'rxjs/operators';
import { AppVisibilityService } from './core/services/app-visibility.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
  imports: [RouterOutlet, CommonModule],
})
export class App implements OnInit {
  protected readonly title = signal('Stay_At');

  constructor(
    private router: Router,
    public visibilityService: AppVisibilityService,
  ) {}

  async ngOnInit() {
    await this.visibilityService.init();

    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-in-out',
      offset: 100,
    });

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      setTimeout(() => {
        AOS.refreshHard();
      }, 200);
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
  }
}
